export default {
 RegisterPrivacyPolicy: {
  title: '隐私政策',
  p1: '感谢您对高盈证券有限公司（下简称“高盈证券”或“我们”或“我司”）的信赖和支持，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全。鉴此，高盈证券制定本《隐私政策》（下称“本政策 /本隐私政策”）并提醒您：',
  p2: '本政策适用于高盈证券提供的产品或服务。如我们及关联公司产品或服务中使用了高盈证券提供的产品或服务但未设独立法律声明及隐私权政策的，则本政策同样适用于该部分产品或服务。',
  p3: '本政策与您使用我们的服务关系紧密，在使用我司产品和服务前，请您务必仔细阅读本政策，在您确认充分理解并同意本政策后使用相关产品和服务。一旦您开始使用我们的各项产品或服务，即表示您已充分理解并同意本政策，并同意我们按照本政策的约定收集、使用、储存、分享和保护您的相关信息。',
  p4: '如对本政策或相关事宜有任何问题，请通过高盈证券客服与我们联系。',
  p5: '本政策将帮助您了解以下内容：',
  p6: '1.我们如何收集和使用您的信息',
  p7: '2.我们如何使用Cookie和同类技术',
  p8: '3.我们如何共享、转让、公开披露您的信息',
  p9: '4.我们如何保护您的信息',
  p10: '5.GDPR所覆盖之个人的更多权利或信息',
  p11: '6.您的权利',
  p12: '7.我们如何保护未成年人的信息',
  p13: '8.您的信息如何在全球范围转移',
  p14: '9.本政策如何更新',
  p15: '10.如何联系我们',
  p16: '一、我们如何收集和使用您的个人信息',
  p17: '在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：',
  p18: '为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；',
  p19: '为实现向您提供我们产品及/或服务的附加功能，经您选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。',
  p20: '您理解并同意：',
  p21: '我们致力于打造多元化的产品和服务以满足您的需求，因我们向您提供的产品和服务种类众多且不同用户选择使用的具体产品/服务范围存在差异，相应的，基本/附加功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；',
  p22: '为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本政策、弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。在此过程中，如果您有任何疑问、意见或建议的，您可通过上述提供的联系方式与我们联系，我们会尽快为您作出解答。',
  p23: '我们会实现本政策下述的各项功能，收集和使用您的个人信息：',
  p24: '(一)帮助您成为我们的用户，以便为您提供网上服务',
  p25: '为遵守法律法规的要求，以及向您提供更个性化、更便捷的服务，当您注册成为高盈证券用户时，您需要至少向我们提供手机号码或电子邮箱地址以创建账号，并完善相关的网络身份识别信息（如头像、昵称及登录密码等）；',
  p26: '授权登录，为了使您可以便捷地使用第三方账号在高盈证券注册或登录，我们可能会根据您的授权从第三方处获取您的账号信息，并与您的高盈证券账号进行绑定，使您可以通过第三方账号直接登录、使用我们的产品及/或服务。我们将根据与第三方的约定，在您授权同意范围内使用您的相关信息。',
  p27: '(二)您在使用我们服务时主动提供的信息',
  p28: '1.依据法律法规及监管规定履行反洗钱义务及进行实名制管理',
  p29: '在您申请开通账户时，根据法律法规及监管规定，您需要按要求提供您的身份信息，包括姓名、国籍/法定居住国、有效身份证件的种类/号码、电子邮箱、居住地址信息、家庭情况（婚姻状况、家庭成员个数）、出生日期、个人签名样式、人脸识别信息或人脸录像信息；当您的国籍、出生地、法定居住地、纳税居住地不一致时，您还需填写您的出生国、纳税管辖国和纳税识别号；当常住地址与身份证地址不同时，您需要另行提供地址证明文件（如含有地址信息的水电费账单/银行结单/驾照/房产证/户口簿等）。',
  p30: '2.依据法律法规及监管规定履行投资适当性判断、客户评级和风险等级评估',
  p31: '根据法律法规要求，在您开通账户时我们需要对您的投资适当性进行判断和评级，并为您提供风险等级评估，为此我们需要您提供职业状况、资产信息（净流动资产范围、净资产范围、总资产范围、净年收入范围）、投资目标和投资经验信息（不同品种交易年限和次数、投资偏好）。当您的职业状况为受雇或创业的时候，您需要补充详细的职业信息，包括单位名称、所在地区及详细地址，公司所属行业及从事的职位名称。',
  p32: '3.存入/提取资金',
  p33: '当您向您的账户存入/提取资金时，根据风控和反洗钱要求，您需要提供您的银行卡号码、银行卡持有人姓名（须与开通资金账户姓名一致）及存入/提取的资金金额信息。',
  p34: '4.客服',
  p35: '当您与我们联系或提出争议纠纷处理或办理个人账户相关业务操作申请时，为了保障您的账户及系统安全，我们需要您提供必要的个人信息以核验您的身份。',
  p36: '为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的通信/通话记录及相关内容（包括账号信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息），如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账号信息和订单信息。',
  p37: '为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。',
  p38: '(三)我们在您使用服务过程中可能收集的个人信息',
  p39: '为了满足法律法规及提供服务的基本要求，保障您的账号安全与系统运行安全，我们会收集您在使用我们服务过程中产生的相关信息并存储为网络日志信息，包括：',
  p40: '1.设备信息',
  p41: '为了保障向您提供的服务的安全稳定和预防风险，我们需要记录您的设备型号、唯一设备标识符、操作系统、IP地址、分辨率、应用下载渠道、当前应用版本号、应用语言设置信息。',
  p42: '2.操作日志信息',
  p43: '当您使用软件时，我们会收集您的使用习惯、使用时长、浏览偏好、页面停留时间等操作日志信息，以便改进产品，为您提供更好的用户体验。',
  p44: '(四)为您提供其他附加服务',
  p45: '为向您提供更便捷、更优质、个性化的产品及/或服务，努力提升您的体验，我们的移动应用会向设备申请一些必要的系统权限。',
  p46_1: '基于位置信息的服务',
  p46_2: '我们会根据移动设备当前位置信息为不同国家的用户提供更优质的行情服务。',
  p47_1: '基于相机/摄像头的附加服务',
  p47_2: '可在开启相机/摄像头权限后使用该功能进行身份证及其他证件/材料拍摄、也可拍摄照片用于评价、分享，以及特定场景下经您授权的人脸识别等功能。当您使用该附加功能进行人脸识别时我们会收集您的面部特征，且严格在经您授权同意的范围内使用，未来如果我们拟使用您的面部信息为您提供其他产品及/或服务功能，我们会再次与您确认。',
  p48_1: '基于相册（图片库）的图片访问及上传的附加服务',
  p48_2: '您在开启相册权限后可使用该功能上传您的照片/图片，以实现更换头像、发表评论、分享、上传身份证等证明材料。',
  p49_1: '基于麦克风的语音技术相关附加服务',
  p49_2: '您可在开启麦克风权限后使用麦克风实现客服语音反馈服务，或与客服进行语音沟通，即使您已同意开启麦克风权限，我们也仅会在您主动点击客户端内麦克风图标或录制视频时通过麦克风获取语音信息。',
  p50_1: '基于通讯录信息的附加服务',
  p50_2: '该权限使您可以更便利地邀请您通讯录内的联系人在高盈证券注册。',
  p51_1: '基于日历的附加服务',
  p51_2: '在您授权开启可读取/写入您日历的权限后，我们将根据您的操作将您关注的公司行动的日期读取/记入系统日历中，以便及时为您提供提醒服务。',
  p52_1: '基于指纹、人脸识别的附加服务',
  p52_2: '我们的应用提供了指纹或人脸识别代替交易密码保障交易安全以及进入交易、资金账户界面前进行指纹或人脸识别的安全附加服务，使您可以获得更加安全的使用体验。',
  p53_1: '基于推送的附加服务',
  p53_2: '我们的应用为您提供了产品活动、相关折扣、金融服务等的提醒及通知，使您及时获知最新信息。',
  p54: '您理解并同意，上述附加服务中的推送服务，您可以在APP设置-推送设置中开启或关闭，关闭权限后您将无法接收到我们推送的内容；其他附加服务可能需要您在您的设备中开启您的位置信息 （地理位置）、摄像头（相机）、相册（图片库）、麦克风（语音）、通讯录及/或日历的访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备设置中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。',
  p56: '(五)为您提供安全保障',
  p57: '为提高您使用我们提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规的情况，我们可能使用或整合您的个人信息、交易信息、设备信息、服务日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合识别您账户的风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。',
  p58: '(六)根据相关法律法规及国家标准，在以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的授权同意:',
  p59: '1.与国家安全、国防安全直接相关的；',
  p60: '2.与公共安全、公共卫生、重大公共利益直接相关的；',
  p61: '3.与犯罪侦查、起诉、审判和判决执行等直接相关的；',
  p62: '4.出于维护您或他人的生命、财产等重大合法权益但又无法及时得到您本人同意的；',
  p63: '5.所收集的个人信息是您自行向社会公众公开的；',
  p64: '6.从合法公开披露的信息中收集您的个人信息，例如：合法的新闻报道、政府信息公开等渠道；',
  p65: '7.根据您的要求签订和履行合同所必需的；',
  p66: '8.用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置服务的故障；',
  p67: '9.为合法的新闻报道所必需的；',
  p68: '10.学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；',
  p69: '11.法律法规规定的其他情形。',
  p70: '(七)其他',
  p71: '请您理解，我们向您提供的服务是不断更新和发展的。如您选择使用了前述说明当中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会通过页面提示、交互流程、协议约定的方式另行向您说明信息收集的范围与目的，并征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。',
  p72: '二、我们如何共享、转让、公开披露您的信息',
  p73: '(一)共享',
  p74: '1.业务协助',
  p75: '我们承诺对您的信息进行严格保密。除法律法规及监管部门另有规定外，我们仅在以下情形中与第三方共享您的信息，第三方包括我们的关联公司、合作的金融机构以及其他合作伙伴。如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施，并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意，或确认第三方已经征得您的同意。',
  p76: '（1）某些产品或服务可能由第三方提供或由我们与第三方共同提供，因此，我们需要向我们合作的第三方（包括清算机构和交易所）提交您的身份信息、联系信息、职业信息、资产信息、投资信息及订单信息后，才能提供您需要的产品或服务；',
  p77: '（2） 在事先获得您明确同意的情况下，我们会在法律法规允许且不违背公序良俗的范围内，依据您的授权范围与第三方共享您的信息。',
  p78: '2.信息验证',
  p79: '依照法律法规的要求，为了有效识别您的身份，我们会在账户开立过程中向合作的第三方身份验证供应商提供您的姓名、出生日期、性别及证件号码信息，以便我们能够识别您为合法、有效的客户，为您完成账户开立并提供后续服务。',
  p80: '3.监管审查',
  p81: '我们的各监管机构、自治协会或有权组织（包括但不限于各交易所及政府机关）出于监督及检查的目的，可能会要求我们提供您的账户信息及交易信息，以便确认我们是否履行了相应的法律义务。',
  p82: '4.客服及投诉处理',
  p83: '当您有疑问需要我们解答、投诉我们、投诉他人或被他人投诉时，为了保护您及他人的合法权益，我们可能会在第三方供应商提供的客服系统中保存您的姓名及联系方式、投诉及沟通的相关内容，并有可能会提供给消费者权益保护部门及监管机关，以便及时解决投诉纠纷，但法律法规明确禁止提供的除外。',
  p84: '(二)转让',
  p85: '我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：',
  p86: '1.事先获得您的明确同意；',
  p87: '2.根据法律法规或强制性的行政或司法要求；',
  p88: '3.在涉及资产转让、收购、兼并、重组或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束。如变更个人信息使用目的时，我们将要求该公司、组织重新取得您的明确同意。',
  p89: '(三)公开披露',
  p90: '除在公布某些中奖活动名单时会脱敏展示中奖者手机号或用户昵称外，原则上我们不会将您的信息进行公开披露。如确需公开披露时，我们会向您告知公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明确同意。',
  p91: '(四)根据相关法律法规及政策标准，在以下情形中，我们可能会依法共享、转让、公开披露您的个人信息无需征得您的同意：',
  p92: '1.与国家安全、国防安全直接相关的；',
  p93: '2.与公共安全、公共卫生、重大公共利益直接相关的；',
  p94: '3.与犯罪侦查、起诉、审判和判决执行等直接相关的；',
  p95: '4.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；',
  p96: '5.您自行向社会公众公开的个人信息；',
  p97: '6.从合法公开披露的信息中收集的个人信息，例如：合法的新闻报道、政府信息公开等渠道。',
  p98: '请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。',
  p99: '四、我们如何保护您的信息',
  p100: '(一)我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们采取物理、技术和行政管理安全措施来降低丢失、误用、非授权访问、披露和更改的风险，包括但不限于传输层数据加密、防火墙和加密存储、物理访问控制以及信息访问授权控制。我们设置了安全程序保护您的信息不会被未经授权的访问所窃取。',
  p101: '(二)我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性，保障您的个人信息。',
  p102: '(三)若您是欧盟用户，根据GDPR条款，我们除了提供系统性的个人数据保护办法外，我们的安全部-个人信息保护专员将会作为数据保护官（DPO）全面负责您的数据保护工作。',
  p103: '(四)我们会采取一切合理可行的措施，尽力避免收集无关的个人信息，我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。',
  p104: '(五)请您知悉并理解，互联网并非绝对安全的环境，我们强烈建议您通过安全方式、复杂可靠的密码使用我们的产品及服务，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即根据本政策中提供的联系方式联络我们，以便我们采取相应措施。',
  p105: '(六)在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知每位用户时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报信息安全事件的处置情况。',
  p106: '五、GDPR所覆盖之个人的更多权利或信息',
  p107: '如果您的个人信息被设立于欧洲经济区（简称“EEA”），对于受《通用数据保护条例》（简称“GDPR”）保护的个人信息而言，您享有一系列与您在我司留存之个人信息相关的法律权利。该等权利包括：',
  p108: '(一)获取有关您个人信息处理的信息并访问您在我司留存的个人信息。请注意，某些情况下，我们有权拒绝访问个人信息（特别是受法律法规特别保护的信息）副本的请求。',
  p109: '(二)如果您的个人信息不准确或不完整，可要求我们进行更正，但如果我们需要您提供有效身份证明文件副本，以证明您的身份信息之真实性，请您配合提供。',
  p110: '(三)在某些情况下您可要求我们删除您的个人信息。请注意，某些情况（如基于公共利益、公共健康或科学及历史研究等目的）下即使您要求我们删除您的个人信息，我们也有权将其保留。',
  p111: '(四)在某些情况下就我们对您个人信息的处理提出反对，并要求我们对您个人信息的处理进行限制。同样，在某些情况下，即使您提出反对或者要求我们限制您个人信息的处理，我们也有权拒绝您的请求。如果有其他正当法定理由，我们也有权不经过您的许可继续使用或处理。',
  p112: '根据GDPR条款，我们除了提供系统性的个人数据保护办法外，还会设置数据保护官（DPO）全面负责您的数据保护工作。',
  p113: '我们会评估我们收到的所有请求及投诉并及时向您提供回复。我们可能要求您提供有效的身份证明文件副本，以便我们履行安全义务并防止未授权的数据披露。若您要求访问数据的请求显然无根据或为超常请求。',
  p114: '对于受GDPR保护的个人信息而言，我们可能会为了特定许可用途将您的个人信息传到EEA以外地区。我们将会确保任何该等国际传递都会根据GDPR或其他相关法律受到适当保护。',
  p115: '六、您的权利',
  p116: '按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：',
  p117: '(一)访问您的个人信息',
  p118: '1.您有权访问您的个人信息，法律法规规定的例外情况除外；',
  p119: '2.您可以通过登录我们的应用主页进入 “我的”页面，点击右上角的“设置”进入“账号管理”与“安全设置”中访问及更改绑定手机和邮箱等信息，在“我的”-“设置”-“安全设置”下修改登录密码和交易密码等。',
  p120: '3.您可以在我们的网站和应用中查看您的交易记录；',
  p121: '4.如果您无法访问上述信息，可以与客服取得联系，我们将在15个工作日内回复您的访问请求；',
  p122: '5.如果您是欧盟用户，根据GDPR条款，您将有权要求我们调取您的个人数据并将其转移到其他数据控制者。',
  p123: '(二)更正您的个人信息',
  p124: '您可以通过“访问您的个人信息”中列明的方式更正或补充个人信息。',
  p125: '如果您无法通过上述方式管理这些个人信息，您可以随时联系我们的客服。我们将在15个工作日内回复您的访问请求。',
  p126: '(三)删除您的个人信息',
  p127: '在以下情形中，您可以向我们提出删除个人信息的请求：',
  p128: '1.如果我们处理您的个人信息行为违反法律规定；',
  p129: '2.如果我们收集和使用您的个人信息，却未征得您的明确同意；',
  p130: '3.如果我们处理个人信息的行为严重违反了与您的约定条款；',
  p131: '4.如果您不再使用我们的产品或服务，或您已主动注销账号；',
  p132: '5.如果我们不再为您提供产品或服务；',
  p133: '6.如果您是欧盟用户，根据GDPR条款您有权要求我们删除您的个人数据。',
  p134: '若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。',
  p135: '(四)保护您的个人信息',
  p136: '您可以通过使用复杂密码且不向任何人透露您的登录密码或账户信息，以保护您的个人信息。一旦您泄漏了您的账号及其密码，可能产生对您不利的后果。如您发现您的账号及其密码因任何原因已经或将遭受泄泄露时，请您立即联络我们的客服，以便我们采取相应措施。但在我们知悉此种情况和在合理时间内采取行动前，我们对此不负任何责任。',
  p137: '当您登录我们的网站或应用，尤其是在公共设备上登录时，会话结束后应立即点击“我的”-“设置”-“退出登录”进行登出。',
  p138: '我们不对因您未能保护个人信息的私密性而导致您的个人信息被第三方访问造成的损失承担责任。若发现任何未经授权使用您的账号的情况或其他安全漏洞，必须立即通知我们。您的协助将有助于我们更好的保护您的个人信息。',
  p139: '(五)改变您授权同意的范围或撤回您的授权',
  p140: '您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。',
  p141: '请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。',
  p142: '(六)注销您的账号',
  p143: '您可以通过以下方式申请注销您的账号：',
  p144: '1.联系我们的客服寻求帮助，协助您申请注销您的账号。',
  p145: '2.发送邮件到指定邮箱，并备注为“注销账户”，工作人员将与您沟通进行销户操作。',
  p146: '在您主动注销账号之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。',
  p147: '(七)约束信息系统自动决策',
  p148: '在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害我们商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。',
  p149: '(八)响应您的上述请求',
  p150: '为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在15个工作日内做出答复。如您不满意，还可以通过我们的客服发起投诉。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将可能拒绝或者视情收取一定成本费用。尤其是对于与您的身份不直接关联的信息、无端重复的信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们有权予以拒绝。',
  p151: '在以下情形中，按照法律法规要求，我们将有权拒绝您的请求：',
  p152: '1.与国家安全、国防安全有关的；',
  p153: '2.与公共安全、公共卫生、重大公共利益有关的；',
  p154: '3.与犯罪侦查、起诉、审判和执行判决等有关的；',
  p155: '4.有充分证据表明个人信息主体存在主观恶意或滥用权利的；',
  p156: '5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；',
  p157: '6.涉及商业秘密的。',
  p158: '七、您的信息如何在全球范围转移',
  p159: '我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内，以下情形除外：',
  p160: '(一)适用的法律有明确规定；',
  p161: '(二)获得您的明确授权；',
  p162: '(三)您直接通过互联网获取跨境服务等个人主动行为。',
  p163: '针对以上情形，我们会确保依据本政策对您的个人信息提供足够的保护。',
  p164: '八、本政策如何更新',
  p165: '我们的隐私政策可能不定期更新和调整。',
  p166: '未经您明确同意，我们不会限制您按照本政策所应享有的权利。我们会在专门页面（如应用中“我的→设置→隐私政策”）上展示最新版的隐私政策。对于重大变更，我们还会提供更为显著的通知（包括我们会通过公示的方式进行通知甚至向您提供弹窗提示）。',
  p167: '本政策所指的重大变更包括但不限于：',
  p168: '(一)我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；',
  p169: '(二)我们在控制权等方面发生重大变化，如并购重组等引起的信息控制者变更等；',
  p170: '(三)个人信息共享、转让或公开披露的主要对象发生变化；',
  p171: '(四)您参与个人信息处理方面的权利及其行使方式发生重大变化；',
  p172: '(五)我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；',
  p173: '(六)个人信息安全影响评估报告表明存在高风险时。',
  p174: '九、如何联系我们',
  p175: '(一)如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，拨打我们的客服电话+852-21872100与我们联系。',
  p176: '(二)一般情况下，我们将在收到您的意见后15个工作日内回复。如果您对我们的回复不满意，特别是如果您认为我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。',
  p177: '(三)我司联系地址：',
  p178: '香港尖沙咀港威大厦 6 座 31 樓 3102 室'
 }
}